import React, { memo } from 'react'
import { string, bool, func, object, number } from 'prop-types'
import classnames from 'classnames'
import { fptiCustomClick, serverData } from '../utils'

import {
  BodyText,
  CaptionText,
  Row,
  Col,
  Icon,
  Divider,
} from '@paypalcorp/pp-react'

const { isInFrame, locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

const SubSection = memo((props) => {
  const {
    subSectionId,
    title,
    desc,
    iconName,
    onSectionClick,
    modal = null,
    navigateTo,
    iconMiddle,
    fptiClickData,
    subModule = {},
    action,
    tabIndex,
  } = props
  const iconClassName = classnames('subSection-icon', {
    'subSection-icon_middle': iconMiddle,
  })

  const isMerchantUser = serverData.isMerchantUser
  const onClickSubSection = (type) => {
    fptiCustomClick(fptiClickData)
    if (!type) {
      if (isInFrame || !modal) {
        top.location.href = navigateTo
      } else {
        onSectionClick(modal)
      }
    }

    if (type === 'subModule') {
      const {
        modal: subModuleModal = null,
        navigateTo: subnavigateTo,
      } = subModule
      if (isInFrame || !subModuleModal) {
        top.location.href = subnavigateTo
      } else {
        onSectionClick(subModuleModal)
      }
    }
  }
  return isMerchantUser ? (
    <div className="merchant-subSection-container_row" id={subSectionId}>
      <div className="merchantSectionDetails">
        <Row className="merchant-row-container">
          <div className="merchantSectionWrapper">
            <section className="column-1">
              <BodyText strong className="merchantSectionTitle">
                {title}
              </BodyText>
            </section>
            <section className="column-2">
              <BodyText className="merchantSectionContent">{desc}</BodyText>
            </section>
          </div>
          <div className="merchantSectionAction">
            <BodyText>
              <a
                id={`${subSectionId}Btn`}
                tabIndex={tabIndex}
                onClick={() => onClickSubSection()}
              >
                {action}
              </a>
            </BodyText>
          </div>
        </Row>
      </div>
      {Object.keys(subModule).length > 0 && subModule.enabled() && (
        <div
          id={subModule.subModuleId}
          className="merchant-subSection-module merchantSubModuleDetails"
        >
          <div className="merchant-subSection-module-divider_container">
            <Divider secondary className="merchant-subSection-module-divider" />
          </div>
          <Row className="merchant-subSection-module_borderLeft">
            <div className={`merchantSubModuleWrapper ${directionality}`}>
              <Col>
                <section className="merchant-sub-module-badge-row">
                  <BodyText strong className="merchantSubModuleTitle">
                    {subModule.title}
                  </BodyText>
                  <div className="merchantSubModuleBadge">
                    {subModule.badgeStatus()}
                  </div>
                </section>

                <BodyText className="merchantSubModuleTitle">
                  {subModule.desc}
                </BodyText>
              </Col>
            </div>
            <div className="merchantSubModuleAction">
              <BodyText>
                <a
                  id={`${subModule.subModuleId}-${subModule.action}`}
                  data-testid="merchantSubModule"
                  tabIndex={tabIndex}
                  onClick={() => onClickSubSection('subModule')}
                >
                  {subModule.action}
                </a>
              </BodyText>
            </div>
          </Row>
        </div>
      )}
    </div>
  ) : (
    <div className="subSection-container_row" id={subSectionId}>
      <button
        type="button"
        className="subSection-header"
        onClick={() => onClickSubSection()}
      >
        <Row>
          <Col sm={1} xs={1} className={iconClassName}>
            {iconName && <Icon name={iconName} size="md" />}
          </Col>
          <Col sm={10} xs={10} className="subSection-description">
            <BodyText strong className="subSection-description_title">
              {title}
            </BodyText>
            <BodyText>{desc}</BodyText>
          </Col>
        </Row>
      </button>
      {Object.keys(subModule).length > 0 && subModule.enabled() && (
        <button
          type="button"
          id={subModule.subModuleId}
          className="subSection-module"
          onClick={() => onClickSubSection('subModule')}
        >
          <div className="subSection-module-divider_container">
            <Divider secondary className="subSection-module-divider" />
          </div>
          <div className="subSection-badge-container">
            <Col
              sm={{ span: 7, offset: 1 }}
              xs={{ span: 9, offset: 1 }}
              className="subSection-module_borderLeft"
            >
              <BodyText strong>{subModule.title}</BodyText>
              <CaptionText>{subModule.desc}</CaptionText>
            </Col>
            <Col sm={3} xs={4} className="subSection-module_chevron">
              {subModule.badgeStatus()}
            </Col>
          </div>
        </button>
      )}
    </div>
  )
})

SubSection.propTypes = {
  title: object,
  desc: object,
  iconName: string,
  iconMiddle: bool,
  fptiClickData: object,
  navigateTo: string,
  modal: object,
  subModule: object,
  onSectionClick: func.isRequired,
  action: string,
  tabIndex: number,
}

SubSection.displayName = 'SubSection'

export default SubSection
